import React from 'react'
import { BrowserRouter , Route, Routes } from 'react-router-dom'
import NavBar from './components/NavBar'
import Home from './components/Home'
import About from './components/About'
import { useTranslation } from "react-i18next";
import Contact from './components/Contact'
import { useEffect } from "react";
import Footer from './components/Footer'

const App = () => {

  const { i18n } = useTranslation();
  useEffect(() => {
    const dir = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = dir; // ده هيغير الاتجاه على مستوى الصفحة كلها
  }, [i18n.language]);

  return (


    <BrowserRouter>

    <div>
      <NavBar/>
  

      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
    </div>
    
    <Footer/>
    </BrowserRouter>

  )
}

export default App